module.exports = __webpack_public_path__ + "img/ui-preview-iot-farm.348beb07.jpg";